// import api from './services/api.js';
import api from './api.js'

export const api_login = async (cnpjcpf, senha) => {
  try {
    const response = await api.post('/Login', {
      CLI_CNPJCPF: cnpjcpf,
      CLI_SENHA_WEB: senha
    });

    return response;
  } catch (error) {
    console.error('Erro no login auth.js:', error.message);
    throw error;
  }
}; 

export const logout = async () => {
  // Implementação do logout no backend
  // await api.post('/auth/logout');
};

export const getUserProfile = async () => {
  try {
    const response = await api.get('/auth/profile');
    return response.data;
  } catch (error) {
    throw error;
  }
};